import colors from 'styles/colors'

type IconProps = {
  color?: string
  width?: number
}

const DEFAULT_LOGO_WIDTH = 32

export const XLogo = ({
  color = colors.WHITE,
  width = DEFAULT_LOGO_WIDTH
}: IconProps) => (
  <svg
    width={width}
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M19.0475 13.5514L30.9621 0H28.1397L17.7899 11.7641L9.5296 0H0L12.4939 17.791L0 32H2.8224L13.7451 19.5741L22.4704 32H32M3.84107 2.08253H8.17707L28.1376 30.0198H23.8005"
        fill={color}
      />
    </g>
  </svg>
)

export const InstagramLogo = ({
  color = colors.WHITE,
  width = DEFAULT_LOGO_WIDTH
}: IconProps) => (
  <svg
    width={width}
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        d="M15.9993 3.42932C20.0935 3.42932 20.5784 3.4449 22.1953 3.51867C23.6903 3.5869 24.5021 3.8367 25.0425 4.04662C25.7582 4.32478 26.269 4.65711 26.8055 5.19364C27.3421 5.73017 27.6744 6.24102 27.9525 6.95668C28.1625 7.49704 28.4123 8.30893 28.4805 9.80385C28.5543 11.4208 28.5699 11.9057 28.5699 15.9999C28.5699 20.0941 28.5543 20.579 28.4805 22.1958C28.4123 23.6908 28.1625 24.5027 27.9525 25.0431C27.6744 25.7587 27.3421 26.2696 26.8055 26.8061C26.269 27.3426 25.7582 27.675 25.0425 27.9531C24.5021 28.163 23.6903 28.4128 22.1953 28.4811C20.5787 28.5548 20.0938 28.5704 15.9993 28.5704C11.9049 28.5704 11.42 28.5548 9.80337 28.4811C8.30838 28.4128 7.49649 28.163 6.95619 27.9531C6.24047 27.675 5.72962 27.3426 5.19309 26.8061C4.65656 26.2696 4.32423 25.7587 4.04613 25.0431C3.83615 24.5027 3.58635 23.6908 3.51812 22.1959C3.44436 20.579 3.42877 20.0941 3.42877 15.9999C3.42877 11.9057 3.44436 11.4208 3.51812 9.80392C3.58635 8.30893 3.83615 7.49704 4.04613 6.95668C4.32423 6.24102 4.65656 5.73017 5.19309 5.19364C5.72962 4.65711 6.24047 4.32478 6.95619 4.04662C7.49649 3.8367 8.30838 3.5869 9.8033 3.51867C11.4202 3.4449 11.9051 3.42932 15.9993 3.42932ZM15.9993 0.666504C11.835 0.666504 11.3129 0.684155 9.67743 0.758776C8.04532 0.833276 6.93075 1.09244 5.95537 1.47151C4.94707 1.86337 4.09197 2.38767 3.23954 3.24009C2.38712 4.09252 1.86282 4.94762 1.47097 5.95592C1.09189 6.93129 0.832727 8.04587 0.758227 9.67798C0.683606 11.3134 0.666016 11.8356 0.666016 15.9999C0.666016 20.1642 0.683606 20.6863 0.758227 22.3218C0.832727 23.9539 1.09189 25.0684 1.47097 26.0438C1.86282 27.0521 2.38712 27.9072 3.23954 28.7596C4.09197 29.6121 4.94707 30.1364 5.95537 30.5282C6.93075 30.9073 8.04532 31.1665 9.67743 31.241C11.3129 31.3156 11.835 31.3332 15.9993 31.3332C20.1636 31.3332 20.6858 31.3156 22.3212 31.241C23.9533 31.1665 25.0679 30.9073 26.0433 30.5282C27.0516 30.1364 27.9067 29.6121 28.7591 28.7596C29.6115 27.9072 30.1358 27.0521 30.5277 26.0438C30.9067 25.0684 31.1659 23.9539 31.2404 22.3218C31.315 20.6863 31.3327 20.1642 31.3327 15.9999C31.3327 11.8356 31.315 11.3134 31.2404 9.67798C31.1659 8.04587 30.9067 6.93129 30.5277 5.95592C30.1358 4.94762 29.6115 4.09252 28.7591 3.24009C27.9067 2.38767 27.0516 1.86337 26.0433 1.47151C25.0679 1.09244 23.9533 0.833276 22.3212 0.758776C20.6858 0.684155 20.1636 0.666504 15.9993 0.666504ZM15.9993 8.12597C11.6507 8.12597 8.12542 11.6513 8.12542 15.9999C8.12542 20.3485 11.6507 23.8738 15.9993 23.8738C20.3479 23.8738 23.8732 20.3485 23.8732 15.9999C23.8732 11.6513 20.3479 8.12597 15.9993 8.12597ZM15.9993 21.111C13.1765 21.111 10.8882 18.8226 10.8882 15.9999C10.8882 13.1771 13.1765 10.8887 15.9993 10.8887C18.8221 10.8887 21.1105 13.1771 21.1105 15.9999C21.1105 18.8226 18.8221 21.111 15.9993 21.111ZM26.0243 7.81488C26.0243 8.8311 25.2005 9.65492 24.1843 9.65492C23.1681 9.65492 22.3443 8.8311 22.3443 7.81488C22.3443 6.79867 23.1681 5.97491 24.1843 5.97491C25.2005 5.97491 26.0243 6.79867 26.0243 7.81488Z"
        fill={color}
      />
    </g>
  </svg>
)

export const LinkedinLogo = ({
  color = colors.WHITE,
  width = DEFAULT_LOGO_WIDTH
}: IconProps) => (
  <svg
    width={width}
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6304 10.8678V30.6458H1.05658V10.8678H7.6304ZM8.06273 4.75077C8.06273 6.64874 6.63588 8.16746 4.34346 8.16746H4.34333H4.30061C2.09451 8.16746 0.667969 6.64874 0.667969 4.75077C0.667969 2.81008 2.13824 1.3335 4.38695 1.3335C6.63589 1.3335 8.02 2.81008 8.06273 4.75077ZM17.8416 30.6458H11.268C11.268 30.6458 11.3543 12.7236 11.268 10.8678H17.8418V13.668C17.8269 13.6909 17.8123 13.7136 17.7979 13.7361H17.8418V13.668C18.7154 12.3203 20.2789 10.4037 23.7661 10.4037C28.0912 10.4037 31.3344 13.2305 31.3344 19.3054V30.6458H24.7611V20.065C24.7611 17.4062 23.8096 15.5925 21.4308 15.5925C19.6148 15.5925 18.5331 16.8157 18.0579 17.9967C17.8843 18.4193 17.8416 19.0098 17.8416 19.6009V30.6458Z"
        fill={color}
      />
    </g>
  </svg>
)
